import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=2cfaa107&scoped=true&"
import script from "./HelpCenter.vue?vue&type=script&lang=ts&"
export * from "./HelpCenter.vue?vue&type=script&lang=ts&"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=2cfaa107&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfaa107",
  null
  
)

export default component.exports